import { parseQueryParams } from '../helpers/URLHelper';
export class Configuration {
  static configuration = null;
  static colors = {};
  static databaseConfigs = {};
  static translations = {};

  constructor() {
    this.pilotId = "10008";
    this.clientId = "heh10";
    this.logoCssClass = "nve-dashboard-logo";
    this.preview = false;
    let queryParams = parseQueryParams(window.location.search);
    this.embed = (queryParams.embed === "1");
    this.loadingIcon = 'loading.gif' ;
    this.namespace = null;
  }

  static setColors(colorsToReplace) {
    this.colors = colorsToReplace;
  }

  static getColors() {
    return {
      colors: this.colors
    };
  }

  /*
  Author: @sarang12
  Description : setDatabaseConfigs() stores some of the configs retrieved from the database in-memory so that these are
                easily accessible in non-react javascript files such as helper.js
                List of keys of configs allowed to be stored can be found in common.js -> ALLOWED_IN_MEMORY_CONFIGS
  */
  static setDatabaseConfigs(configs) {
    this.databaseConfigs = configs;
  }

  static getDatabaseConfigs() {
    return this.databaseConfigs;
  }

  /*
  Author: @sarang12
  Description : setTranslations() stores some of the translations retrieved from the database in-memory so that these are
                easily accessible in non-react javascript files such as helper.js
                List of keys of translations allowed to be stored can be found in common.js -> ALLOWED_IN_MEMORY_TRANSLATIONS
  */
  static setTranslations(translations) {
    this.translations = translations;
  }

  static getTranslations(){
   return this.translations;
  }

  static getConfiguration() {
    if(this.configuration) {
      return this.configuration;
    }
    if(typeof (window) === "undefined") {
      this.configuration = new Configuration();
      return this.configuration;
    }

    const host = window.location.host;

    if (ConfigurationDukeSMB.isDomainSupported(host)) {
      this.configuration = new ConfigurationDukeSMB();
    } else if (ConfigurationDuke.isDomainSupported(host)) {
      this.configuration = new ConfigurationDuke();
    }
    else if (ConfigurationSCG.isDomainSupported(host)) {
      this.configuration = new ConfigurationSCG();
    }
    else if (ConfigurationNVE.isDomainSupported(host)) {
      this.configuration = new ConfigurationNVE();
    }
     else if (ConfigurationSimply.isDomainSupported(host)) {
      this.configuration = new ConfigurationSimply();
    }
    else if (ConfigurationCOH.isDomainSupported(host)) {
      this.configuration = new ConfigurationCOH();
    }
     else if (ConfigurationHydroottawa.isDomainSupported(host)) {
      this.configuration = new ConfigurationHydroottawa();
    }
     else if (ConfigurationFPL.isDomainSupported(host)) {
      this.configuration = new ConfigurationFPL();
    }
     else if (ConfigurationMCE.isDomainSupported(host)) {
      this.configuration = new ConfigurationMCE();
    }
    else if(ConfigurationUBCSMB.isDomainSupported(host)){
      this.configuration = new ConfigurationUBCSMB();
    }
     else if (ConfigurationDemo.isDomainSupported(host)) {
      this.configuration = new ConfigurationDemo();
    }
    else if (ConfigurationBchydro.isDomainSupported(host)) {
      this.configuration = new ConfigurationBchydro();
    }
    else if(ConfigurationTepco.isDomainSupported(host)) {
      this.configuration = new ConfigurationTepco();
    }
    else if(ConfigurationRMP.isDomainSupported(host)) {
      this.configuration = new ConfigurationRMP();
    }
    else if(ConfigurationPreview.isDomainSupported(host)) {
      this.configuration = new ConfigurationPreview();
    }
    else if (ConfigurationPSEG.isDomainSupported(host)) {
      this.configuration = new ConfigurationPSEG();
    }
    else if(ConfigurationSorgenia.isDomainSupported(host)){
      this.configuration = new ConfigurationSorgenia();
    }
    else if(ConfigurationPP.isDomainSupported(host)){
      this.configuration = new ConfigurationPP();
    }
    else {
      this.configuration = new Configuration();
    }

    return this.configuration;
  }
}

class ConfigurationDuke extends Configuration {
  constructor() {
    super();
    this.pilotId = "10010";
    this.clientId = "duke-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^duke(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationDukeSMB extends Configuration {
  constructor() {
    super();
    this.pilotId = "10014";
    this.clientId = "duke-smb-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^duke-smb(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}


class ConfigurationSCG extends Configuration {
  constructor() {
    super();
    this.pilotId = "10033";
    this.clientId = "scg-dashboard";
    this.logoCssClass = "scg-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^scg(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationNVE extends Configuration {
  constructor() {
    super();
    this.pilotId = "10009";
    this.clientId = "nve-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^nve(-?)([a-z]*(-?)[a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationSimply extends Configuration {
  constructor() {
    super();
    this.pilotId = "10030";
    this.clientId = "simply-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^simplyenergy([0-9]*[a-z]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationCOH extends Configuration {
  constructor() {
    super();
    this.pilotId = "10032";
    this.clientId = "coh-dashboard";
    this.logoCssClass = "coh-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^coh(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationMCE extends Configuration {
  constructor() {
    super();
    this.pilotId = "10036";
    this.clientId = "mce-dashboard";
    this.loadingIcon='loadingMce.svg';
  }

  static isDomainSupported(host) {
    return new RegExp(/^mce(-?)([0-9]*[a-z]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationHydroottawa extends Configuration {
  constructor() {
    super();
    this.pilotId = "10008";
    this.clientId = "heh10";
  }

  static isDomainSupported(host) {
    return (new RegExp(/^hydro-ottawa(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host)) || (new RegExp(/^hydroottawa(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host));
  }
}

class ConfigurationFPL extends Configuration {
  constructor() {
    super();
    this.pilotId = "10017";
    this.clientId = "fpl-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^fpl(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationDemo extends Configuration {
  constructor() {
    super();
    this.pilotId = "10034";
    this.clientId = "ubc-dashboard";
    this.logoCssClass = "utility-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^ubc(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationBchydro extends Configuration {
  constructor() {
    super();
    this.pilotId = "10035";
    this.clientId = "bchydro-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^bchydro(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationTepco extends Configuration {
  constructor() {
    super();
    this.pilotId = "30001";
    this.clientId = "tepco-dashboard";
    this.namespace = 'JP';
  }

  static isDomainSupported(host) {
    return new RegExp(/^tepco(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationPSEG extends Configuration {
  constructor() {
    super();
    this.pilotId = "10037";
    this.clientId = "pseg-dashboard";
  }

  static isDomainSupported(host) {
    return new RegExp(/^pseg(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationRMP extends Configuration {
  constructor() {
    super();
    this.pilotId = "10021";
    this.clientId = "rmp-dashboard";
    this.logoCssClass = "rmp-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^rmp(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationPreview extends Configuration {

  constructor() {
    super();
    let queryParams = parseQueryParams(window.location.search);

    this.pilotId = queryParams['pilot-id'];
    this.clientId = queryParams['client-id'];
    this.externalParams = queryParams['external-params'];
    this.locale = queryParams['locale'];
    this.logoCssClass = "utility-logo";
    this.preview = true;
  }

  static isDomainSupported(host) {
    return new RegExp(/^preview(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationSorgenia extends Configuration {

  constructor() {
    super();
    this.pilotId = 20013;
    this.clientId = 'sorgenia-dashboard';
    this.logoCssClass = "utility-logo";
    this.preview = false;
  }

  static isDomainSupported(host) {
    return new RegExp(/^sorgenia(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationPP extends Configuration {

  constructor() {
    super();
    this.pilotId = "10024";
    this.clientId = 'pp-dashboard';
    this.logoCssClass = "pp-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^pp(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host);
  }
}

class ConfigurationUBCSMB extends Configuration {

  constructor() {
    super();
    this.pilotId = "10040";
    this.clientId = 'ubcsmb-dashboard';
    this.logoCssClass = "utility-logo";
  }

  static isDomainSupported(host) {
    return new RegExp(/^ubcsmb(-?)([a-z]*[0-9]*)\.bidgely\.com$/).test(host)
  }
}
